export default __webpack_public_path__ + "static/media/SpecialColors.d2a038e4.png";